<template>
  <div
    :id="id"
    :class="['checkbox', { 'is-active': isActive, disabled }]"
    role="checkbox"
    :aria-checked="isActive"
    :aria-disabled="disabled"
    @click="toggleChecked"
    @keydown.space.prevent="toggleChecked"
    tabindex="0"
  >
    <div class="checkbox-input">
      <svg
        width="19"
        height="17"
        viewBox="0 0 19 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.9225 2.01961C18.188 2.25294 18.2141 2.65732 17.9807 2.92283L7.43528 14.9228C7.31991 15.0541 7.15587 15.1325 6.98126 15.1398C6.80664 15.1471 6.63663 15.0827 6.51071 14.9615L1.05617 9.71147C0.801501 9.46636 0.79376 9.06121 1.03887 8.80654C1.28399 8.55188 1.68914 8.54413 1.94381 8.78925L6.91585 13.5748L17.0192 2.07789C17.2526 1.81238 17.657 1.78629 17.9225 2.01961Z"
          fill="rgb(98, 27, 77)"
        />
      </svg>
    </div>

    <div v-if="label" class="checkbox-label">
      {{ label }}
    </div>
  </div>
</template>

<script>
export default {
  name: "checkbox-component",
  props: {
    id: String,
    onClick: {
      type: Function,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    label: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggleChecked() {
      if (this.disabled) return;
      this.onClick(!this.isActive);
    },
  },
};
</script>
